import { createTheme } from '@mui/material';

import { darkPalette } from './palette';

/**
 * Dark theme
 * Combines palette, typography, and component styles
 */
export const darkTheme = createTheme({
  palette: darkPalette,
});
